export default "https://assets-v2.scaler.com/packs/files/acs-banner-bg.573c1f.webp";